import { RootState } from 'src/store';
import { createSelector } from '@reduxjs/toolkit';

const safeSelector = (rootState: RootState) => rootState.modals;
export const currentModalSelector = createSelector(safeSelector, (state) => state.currentModal);
export const currentModalVisibleSelector = createSelector(safeSelector, (state) => state.visible);
export const currentModalDataSelector = createSelector(safeSelector, (state) => state.data);
